"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var social_networks_1 = tslib_1.__importStar(require("../../../../constants/social-networks"));
var build_url_1 = require("../../../../../common/utils/url/build-url");
var get_origin_1 = require("../../../../../common/utils/url/get-origin");
var utils_1 = require("../utils");
var open_popup_1 = tslib_1.__importDefault(require("../../../../../common/utils/open-popup"));
var tooltip_1 = tslib_1.__importDefault(require("../../../../ui-components/tooltip/tooltip"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../../ui-components/inline-icon/inline-icon"));
var styles_scss_1 = tslib_1.__importDefault(require("../styles.scss"));
var TwitterIcon_1 = tslib_1.__importDefault(require("../../../../../icons/compiled/components/TwitterIcon"));
var Twitter = /** @class */ (function (_super) {
    tslib_1.__extends(Twitter, _super);
    function Twitter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a = _this.props, instanceInfo = _a.instanceInfo, videoId = _a.videoId, channelId = _a.channelId, descriptionText = _a.descriptionText, canShareContent = _a.canShareContent, content = _a.content;
            var instanceId = instanceInfo.instanceId, componentId = instanceInfo.componentId, sitePageId = instanceInfo.sitePageId, siteUrl = instanceInfo.siteUrl, biToken = instanceInfo.biToken;
            var baseUrl = (0, get_origin_1.getOrigin)(siteUrl);
            var shareProxyUrl = (0, build_url_1.buildUrl)("".concat(baseUrl, "/").concat(social_networks_1.shareMappingPath, "/").concat(sitePageId), {
                'instance-id': instanceId,
                'component-id': componentId,
                'channel-id': channelId,
                'video-id': videoId,
                'bi-token': biToken,
                bsi: (0, utils_1.getBsi)(),
            });
            if (canShareContent) {
                var url = (0, build_url_1.buildUrl)('https://twitter.com/intent/tweet', {
                    // eslint-disable-next-line
                    original_referer: siteUrl,
                    text: descriptionText
                        .replace('{siteUrl}', shareProxyUrl)
                        .replace('{title}', content.title),
                });
                (0, open_popup_1.default)(url);
            }
            _this.props.onShare(social_networks_1.default.TWITTER);
        };
        return _this;
    }
    Twitter.prototype.render = function () {
        var _a = this.props, className = _a.className, dataHook = _a.dataHook, ariaLabel = _a.ariaLabel, tooltip = _a.tooltip;
        return (react_1.default.createElement(tooltip_1.default, { content: tooltip },
            react_1.default.createElement("button", { onClick: this.onClick, "data-hook": dataHook, className: className, "aria-label": ariaLabel },
                react_1.default.createElement(inline_icon_1.default, { icon: react_1.default.createElement(TwitterIcon_1.default, null), className: styles_scss_1.default.icon }))));
    };
    Twitter.propTypes = {
        dataHook: prop_types_1.default.string,
        onShare: prop_types_1.default.func,
        content: prop_types_1.default.object,
        className: prop_types_1.default.string,
        descriptionText: prop_types_1.default.string,
        canShareContent: prop_types_1.default.bool,
        tooltip: prop_types_1.default.node,
        ariaLabel: prop_types_1.default.string,
        videoId: prop_types_1.default.string,
        channelId: prop_types_1.default.string,
        instanceInfo: prop_types_1.default.shape({
            instanceId: prop_types_1.default.string,
            componentId: prop_types_1.default.string,
            sitePageId: prop_types_1.default.string,
            siteUrl: prop_types_1.default.string,
        }),
    };
    Twitter.defaultProps = {
        onShare: lodash_1.noop,
    };
    return Twitter;
}(react_1.default.Component));
exports.default = Twitter;
//# sourceMappingURL=twitter.js.map